<template>
    <v-card flat color="transparent">
        <v-layout align-center justify-center>
            <v-flex lg3 md4 sm4 xs10>
                <v-card-title class="justify-center">
                    <p class="headline">
                        Forgot Password
                    </p>
                </v-card-title>
                <v-card-text>
                    <v-form @submit.prevent="submit">
                        <v-text-field
                                outlined
                                ref="username"
                                v-model.trim="$v.username.$model"
                                label="Username"
                                :error-messages="usernameError"
                                error-count=2
                                required>
                        </v-text-field>
                        <v-text-field
                                outlined
                                ref="verificationCode"
                                v-model.trim="$v.verificationCode.$model"
                                type="number"
                                label="Verification Code"
                                error-count=2
                                :error-messages="verificationCodeError"
                                :keyup="verificationCodeLength()"
                                v-if="showVerifCodeField"
                                required>
                        </v-text-field>
                        <v-text-field
                                outlined
                                ref="password"
                                v-model.trim="$v.password.$model"
                                type="password"
                                label="New Password"
                                :error-messages="passwordError"
                                v-if="showPasswordField"
                                hint="Must contains lower and upper case character, one number and one symbol, ie. $12&*!)JHSert"
                                required>
                        </v-text-field>
                        <v-text-field
                                outlined
                                ref="password"
                                v-model.trim="$v.checkPassword.$model"
                                type="password"
                                label="Retype Password"
                                :error-messages="passwordCheckError"
                                v-if="showPasswordField"
                                required>
                        </v-text-field>
                        <!--<v-alert-->
                                <!--:value="true"-->
                                <!--color="success"-->
                                <!--icon="check_circle"-->
                                <!--outline-->
                                <!--v-if="showVerifCodeField"-->
                        <!--&gt;-->
                            <!--Verification code was sent to your email 1.-->
                        <!--</v-alert>-->
                        <v-btn text
                               color="primary"
                               @click="forgotPassword"
                               v-if="showVerifCodeField"
                               small>
                            Resend Code
                        </v-btn>

                        <v-alert
                                v-model="alert.show"
                                dismissible
                                outlined
                                :type= "alert.type">
                            {{alert.msg}}
                        </v-alert>

                        <div class="mt-3"></div>

                        <v-layout align-center justify-center row warp>
                            <v-flex>
                                <v-btn  color="primary"
                                        v-if="showSubmit"
                                        type="submit"
                                        block
                                        large
                                        @click.prevent="submit"
                                >
                                    SEND
                                </v-btn>
                            </v-flex>
                            <v-spacer></v-spacer>
                            <v-flex>
                                <v-btn text
                                       large
                                       block
                                       @click.stop="close">
                                    {{showSubmit ? 'Cancel' : 'Log In'}}
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>
            </v-flex>
        </v-layout>
    </v-card>

</template>

<script>
    import {Auth} from 'aws-amplify';
    import { required, minLength} from 'vuelidate/lib/validators'
    import { AmplifyEventBus } from 'aws-amplify-vue';

    export default {
        name: "ForgotPassword",
        data(){
            return{
                username:'',
                verificationCode: '',
                password:'',
                showSubmit: true,
                checkPassword: null,
                showVerifCodeField: false,
                maxVerifCode: 6,
                showPasswordField: false,
                alert: {
                    show: false,
                    type:'success',
                    msg: 'Success'
                }
            }
        },
        validations: {
            username: {
                required: required,
                minLength: minLength(6)
            },
            verificationCode: {
                required: required,
                minLength: minLength(6)

            },
            password: {
                required: required,
                minLength: minLength(8)
            },
            checkPassword: {
                sameAsPassword: function () {
                    return this.checkPassword === this.password;
                }
            }
        },
        computed:{
            usernameError(){
                const errors = []
                if (!this.$v.username.$dirty) {
                    return errors
                }

                !this.$v.username.minLength && errors.push('Username must be at least '+
                    this.$v.username.$params.minLength.min +' characters long')
                !this.$v.username.required && errors.push('Username is required.')
                return errors
            },
            verificationCodeError(){
                const errors = []
                if (!this.$v.verificationCode.$dirty) {
                    return errors
                }

                !this.$v.verificationCode.minLength && errors.push('Verification Code must be '+
                    this.$v.verificationCode.$params.minLength.min +' digits long')
                !this.$v.verificationCode.required && errors.push('Verification Code is required.')
                return errors
            },
            passwordError(){
                const errors = []
                if (!this.$v.password.$dirty) {
                    return errors
                }

                !this.$v.password.minLength && errors.push('Password must be at least '+
                    this.$v.password.$params.minLength.min +' characters long')
                !this.$v.password.required && errors.push('Password is required.')
                return errors
            },
            passwordCheckError(){
                const errors = []
                if (!this.$v.password.$dirty) {
                    return errors
                }

                !this.$v.checkPassword.sameAsPassword && errors.push('Passwords need to match.')
                return errors
            },
        },
        methods: {
            async forgotPassword(){

                try {
                        let promise = await Auth.forgotPassword(this.username);

                        this.setAlert('success', 'Verification code was sent to your email.');
                        this.showVerifCodeField = true;
                        return;
                }
                catch (e) {
                    this.$emit('submit', false)
                    if(e.code === 'UserNotFoundException'){
                        this.setAlert('error', 'User Not Found');
                        return;
                    }
                    this.setAlert('error', e.message);
                }
            },
            async createNewPassword(){
                try {
                    let promise = await Auth.forgotPasswordSubmit(this.username, this.verificationCode, this.password);
                    AmplifyEventBus.$emit('authState', 'signedIn');
                    this.alert.show = false;
                }
                catch (e) {
                    this.$emit('submit', false)
                    this.setAlert('error', e.message);
                }
            },
            async verifyCode(){
                try {
                    //let promise = await Auth.verifyCurrentUserAttributeSubmit('r***@g***.com', this.verificationCode)

                    this.alert.show = false;
                    this.showPasswordField = true;
                }
                catch (e) {
                    this.$emit('submit', false)
                    this.setAlert('error', e.message);
                }
            },
            submit(){
                this.$v.username.$touch()

                if(this.$v.username.$anyError){
                    return;
                }

                if(this.showVerifCodeField !== true && this.showPasswordField !== true){
                    this.forgotPassword();
                }
                else{
                    this.createNewPassword();
                }

                //submit template
                //submit docs
                this.$emit('submit', true);

            },
            close(){
                this.$emit('close', true)
                AmplifyEventBus.$emit('authState', 'signedIn');
            },
            setAlert(type, msg){
                this.alert.show = true;
                this.alert.type = type;
                this.alert.msg = msg;
            },
            verificationCodeLength(){
                this.verificationCode.length >= this.maxVerifCode ? this.showPasswordField = true : this.showPasswordField = false;
            },
        }
    }
</script>

<style scoped>

</style>